import React from 'react';
import '../../styles/GSIDA.css';

const partners = [
  {
    id: 1,
    name: "United Nations",
    logo: "https://commons.wikimedia.org/wiki/Special:FilePath/Emblem_of_the_United_Nations.svg",
  },
  {
    id: 2,
    name: "African Union",
    logo: "https://commons.wikimedia.org/wiki/Special:FilePath/African_Union_logo.png",
  },
  {
    id: 3,
    name: "NATO",
    logo: "https://images.seeklogo.com/logo-png/9/1/nato-logo-png_seeklogo-97458.png",
  },
  {
    id: 4,
    name: "UNITAR",
    logo: "https://upload.wikimedia.org/wikipedia/commons/3/3c/Unitar_vertical_logo_blue-png.png",
  },
  {
    id: 5,
    name: "Université Ibn Zohr",
    logo: "https://images.seeklogo.com/logo-png/31/1/universite-ibn-zohr-agadir-maroc-logo-png_seeklogo-315828.png",
  },
  {
    id: 6,
    name: "CIGSIDA",
    logo: "https://cigsida.com/static/media/logo-cigisdacolor.801c3bbf5e03ad574d84.png",
  },
];

export default function GSIDAPartners() {
  return (
    <div className="gsida-partners-page">
      <div className="gsida-header-banner partners-banner">
         <div className="banner-overlay">
            <h1>Partenaires Institutionnels</h1>
            
         </div>
      </div>

      <div className="gsida-content-container">
        <section className="partners-logos-section">
            <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>Nos Partenaires Institutionnels Stratégiques</h3>
            </div>
            
             <p>
               Le Congrès GSIDA 2026 est honoré de collaborer avec des partenaires institutionnels de premier plan qui partagent notre vision d'une gouvernance sécuritaire innovante et inclusive. Ces partenariats renforcent notre capacité à offrir une plateforme d'échange et de collaboration internationale de haut niveau.
             </p>
           <div className="logos-grid">
              {partners.map(p => (
                <div className="partner-logo-box" key={p.id}>
                   <img src={p.logo} alt={p.name} />
                   <span>{p.name}</span>
                </div>
              ))}
           </div>
        </section>

       
      </div>
    </div>
  );
}
